import { render } from "./FormConsentimientoCliente.vue?vue&type=template&id=3d4164a5&scoped=true"
import script from "./FormConsentimientoCliente.vue?vue&type=script&lang=js"
export * from "./FormConsentimientoCliente.vue?vue&type=script&lang=js"

import "./FormConsentimientoCliente.vue?vue&type=style&index=0&id=3d4164a5&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d4164a5"]])

export default __exports__